import { api } from './api'

export const productsService = {
  // Получить все товары
  getAll: async (params = {}) => {
    const response = await api.get('/products/', { params })
    const items = Array.isArray(response.data)
      ? response.data
      : response.data.results || []
    return items.map(normalizeProductImages)
  },

  // Получить товар по ID
  getById: async (id) => {
    const response = await api.get(`/products/${id}/`)
    return normalizeProductImages(response.data)
  },

  // Получить товары по категории
  getByCategory: async (categorySlug) => {
    const response = await api.get('/products/', {
      params: { category__slug: categorySlug },
    })
    return Array.isArray(response.data) ? response.data : response.data.results || []
  },

  // Получить все категории
  getCategories: async () => {
    const response = await api.get('/categories/')
    return Array.isArray(response.data) ? response.data : response.data.results || []
  },
}

// --- helpers ---
function normalizeProductImages(product) {
  if (!product?.images) return product
  const sorted = [...product.images].sort((a, b) => {
    if (a.is_main && !b.is_main) return -1
    if (!a.is_main && b.is_main) return 1
    return (a.order || 0) - (b.order || 0)
  })
  return { ...product, images: sorted }
}
